import classNames from "classnames";
import { hyphenate, isPresent } from "neetocist";
import { handleMetaClick } from "neetocommons/react-utils";
import { LeftArrow } from "neetoicons";
import { Typography, Button } from "neetoui";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import Container from "components/Container";
import Header from "components/Header";
import HelpPopover from "components/HelpPopover";

import { EMBED_ICONS } from "./constants";

const EmbedSelector = ({
  options,
  goBackLink,
  title,
  titleHelpPopoverProps,
  subTitleHelpPopoverProps,
}) => {
  const { t } = useTranslation();

  const history = useHistory();
  const location = useLocation();

  return (
    <Container className="neeto-molecules-embed-landing-page py-8">
      {goBackLink && (
        <Button
          className="mb-4"
          data-testid="back-button"
          icon={LeftArrow}
          iconPosition="left"
          label={t("neetoMolecules.productEmbed.backToShare")}
          size="small"
          style="link"
          to={goBackLink}
        />
      )}
      <Header
        {...{ titleHelpPopoverProps }}
        className="py-0"
        data-testid="embed-selector-header"
        title={t("neetoMolecules.productEmbed.title")}
      />
      <div className="neeto-molecules-embed-landing-page__container mx-auto w-full max-w-5xl py-6 md:py-10">
        <Typography className="mb-2" style="h2">
          {title ||
            t("neetoMolecules.productEmbed.embedSelectionTitle", {
              productName: globalProps.appName,
            })}
          {isPresent(subTitleHelpPopoverProps) && (
            <HelpPopover
              {...subTitleHelpPopoverProps}
              className={classNames(
                "ml-2 align-middle",
                subTitleHelpPopoverProps?.className
              )}
            />
          )}
        </Typography>
        <Typography className="mb-8" style="body1">
          {t("neetoMolecules.productEmbed.embedSelectionDescription")}
        </Typography>
        <div className="neeto-molecules-embed-landing-page__cards-wrapper grid w-full grid-cols-1 flex-wrap gap-6 md:grid-cols-3">
          {Object.entries(options).map(
            ([key, { label, description, embedIcon }]) => {
              const EmbedIcon = embedIcon || EMBED_ICONS[key];

              return (
                <button
                  className="neeto-molecules-embed-landing-page__card flex w-full flex-col"
                  data-testid={`embed-selector-card-${hyphenate(key)}`}
                  key={key}
                  onClick={handleMetaClick(
                    history,
                    `${location.pathname}?type=${hyphenate(key)}`
                  )}
                >
                  <span className="neeto-molecules-embed-landing-page__card-icon mb-6 block">
                    <EmbedIcon className="neeto-ui-text-gray-200 h-auto w-full max-w-72" />
                  </span>
                  <Typography className="mb-2" style="h4">
                    {label}
                  </Typography>
                  <Typography style="body2">{description}</Typography>
                </button>
              );
            }
          )}
        </div>
      </div>
    </Container>
  );
};

export default EmbedSelector;
